import { TTreeOption } from '@/common/components/redesigned/TreeMultiselect/types';
import { MONTH_NAMES } from '@/common/constants/months';
import { PERIODS_SEPARATORS } from '@/common/constants/periods';

import { COST_TYPE_FILTER_OPTIONS } from '../constants/options';
import { CostTypes } from '../types/common-aggregated';
import { logParseErrors } from './logger';

const YEAR_MONTH_RE = new RegExp(`^([0-9]{4})${PERIODS_SEPARATORS.month}([0-9]{1,2})$`);

export const parseYearMonth = (
  yearMonth: string,
): { year: number; month: number; labelShort: string; originalValue: string } => {
  const match = YEAR_MONTH_RE.exec(yearMonth);

  if (!match) {
    return { year: NaN, month: NaN, labelShort: yearMonth, originalValue: yearMonth };
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const idx = Math.max(0, Math.min(month - 1, MONTH_NAMES.length - 1));
  const labelShort = MONTH_NAMES[idx];

  return { year, month, labelShort, originalValue: yearMonth };
};

export const getCostTypeName = (costType: CostTypes): string => {
  return COST_TYPE_FILTER_OPTIONS.find((option) => option.value === costType)?.label || '';
};

export const getYearsFromPeriods = (periods: string[]): number[] => {
  const years = new Set<number>();
  for (const period of periods) {
    if (period.includes(PERIODS_SEPARATORS.month)) {
      const { year, month } = parseYearMonth(period);
      if (Number.isNaN(year) || Number.isNaN(month)) {
        console.log('Ошибка парсинга периода', period);
        continue;
      }
      years.add(year);
    } else {
      const numericYear = Number(period);
      if (Number.isNaN(numericYear) || numericYear <= 0) {
        logParseErrors(period);
        continue;
      }
      years.add(numericYear);
    }
  }
  return Array.from(years).sort((yearA, yearB) => yearA - yearB);
};

export const findTreeLabelByValue = (tree: TTreeOption[], value: string | number): string | null => {
  const stack: TTreeOption[] = Array.isArray(tree) ? [...tree] : [];
  while (stack.length) {
    const node = stack.pop() as TTreeOption;
    if (node.value === value) return node.label;
    if (Array.isArray(node.options) && node.options.length) {
      stack.push(...node.options);
    }
  }
  return null;
};

export const getMonthsYYYYMMFromPeriods = (periods: string[]): string[] => {
  const result: string[] = [];
  for (const period of periods) {
    if (period.includes(PERIODS_SEPARATORS.month)) {
      const { year, month } = parseYearMonth(period);
      if (Number.isNaN(year) && Number.isNaN(month) && !year && !month) {
        logParseErrors(period);
        continue;
      }

      result.push(`${year}${PERIODS_SEPARATORS.month}${month}`);
    } else {
      const numericYear = Number(period);
      if (Number.isNaN(numericYear) || numericYear <= 0) {
        logParseErrors(period);
        continue;
      }
      result.push(`${numericYear}${PERIODS_SEPARATORS.month}12`);
    }
  }
  return result;
};
